<div class="toolbar">
  <h2>Debugging</h2>
  <button class="btn btn-default" (click)="clear()">Clear</button>
</div>

<div class="debug__container">
  <div class="debug__list">

    <div class="debug__item" *ngFor="let item of items">
      <div>{{item.type}}</div>
      <div>{{item.message}}</div>
    </div>

  </div>

  <div class="debug__history">
    <div class="debug__history__item" *ngIf="currentHistoryItem">
      <div class="d__title">current</div>
      <div class="d__key1">key</div>
      <div class="d__value1">{{currentHistoryKey}}</div>
      <div class="d__key2">title</div>
      <div class="d__value2">{{currentHistoryItem.title}}</div>
      <div class="d__key3">url</div>
      <div class="d__value3">{{currentHistoryItem.url}}</div>

    </div>
    <div class="debug__history__item" *ngIf="backHistoryItem">
      <div class="d__title">back</div>
      <div class="d__key1">key</div>
      <div class="d__value1">{{backHistoryKey}}</div>
      <div class="d__key2">title</div>
      <div class="d__value2">{{backHistoryItem.title}}</div>
      <div class="d__key3">url</div>
      <div class="d__value3">{{backHistoryItem.url}}</div>
    </div>
  </div>
</div>